<template>
<div class="dboard-card">
  <div class="row">
    <ul class="grid-list">
      <li>
        <div class="col-lg-12">
          <div class="dboard-card-title">
            Total Spend for Month
          </div>
          <div class="dboard-card-panel">
            <div class="dboard-card-panel-section">
              <div class="dboard-card-section-primarynumber primary-text">
                79,000
                <span class="italic">INR</span>
              </div>
              <div class="bar-spendchart">
                <LineChart/>
              </div>
            </div>
          </div>
        </div>
      </li>

      <li>
        <div class="col-lg-12">
          <div class="dboard-card-title">
            Estimated Freight
          </div>
          <div class="dboard-card-panel">
            <div class="dboard-card-panel-section">
              <div class="dboard-card-section-primarynumber primary-text">
                2,08,982
                <span class="italic">INR</span>
              </div>
            </div>
            <div class="clearfix"></div>

            <div class="dboard-card-panel-section dsplinline-left">
              <div class="dboard-card-title">
                Primary Movement
              </div>
              <div class="dboard-card-section-tertiarynumber primary-text">
                2,08,982
                <span class="italic">INR</span>
              </div>
            </div>

            <div class="dboard-card-panel-section dsplinline-right">
              <div class="dboard-card-title">
                Secondary Movement
              </div>
              <div class="dboard-card-section-tertiarynumber primary-text">
                2,08,982
                <span class="italic">INR</span>
              </div>
            </div>

          </div>
        </div>
      </li>

      <li>
        <div class="col-lg-12">
          <div class="dboard-card-title">
            Invoice Generated
          </div>
          <div class="dboard-card-panel">
            <div class="dboard-card-panel-section">
              <div class="dboard-card-section-primarynumber sec-text">
                1,08,456
                <span class="italic">INR</span>
              </div>
            </div>
            <div class="clearfix"></div>
            <div class="dboard-card-panel-section dsplinline-left">
              <div class="dboard-card-title">
                GST
              </div>
              <div class="dboard-card-section-tertiarynumber primary-text">
                8,982
                <span class="italic">INR</span>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</div>
</template>
<script>
import LineChart from '../common/charts/LineChart';

export default {
  components: {
    LineChart,
  },
};
</script>
